// 🔴 15/09/2026: ESTE FICHEIRO NAO MUDA COM O CONSENT MODE v2, e e' de proposito.
// O `googleAnalytics.js` passou a carregar sempre, com os sinais negados por
// omissao, porque o Google tem um mecanismo (Consent Mode) que manda um ping
// sem cookies e usa-o para modelar. **A Meta nao tem equivalente**: ou se
// carrega o Pixel, ou nao se carrega. Por isso aqui mantem-se o bloqueio duro,
// que e' o lado seguro. NAO "uniformizar" com o GA sem perceber a diferenca.

// Meta Pixel — carregado apenas após consentimento de cookies.
// A chave de consentimento é a mesma usada em components/CookieConsent.jsx
// ('pigmentos-cookie-consent' = 'accepted' | 'rejected').

const PIXEL_ID = '1696230398251870';
const CONSENT_KEY = 'pigmentos-cookie-consent';

let loaded = false;

function loadPixel() {
  if (loaded || typeof window === 'undefined') return;
  loaded = true;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

// Dispara um evento standard do Meta (ex.: 'Lead', 'Contact') — só se o pixel já estiver carregado.
export function trackMetaEvent(name, params) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', name, params || {});
  }
}

// Liga o pixel ao consentimento: carrega já se aceite, senão espera pela aceitação.
export function setupMetaPixelConsent() {
  if (typeof window === 'undefined') return;
  try {
    if (localStorage.getItem(CONSENT_KEY) === 'accepted') {
      loadPixel();
      return;
    }
  } catch {
    /* localStorage indisponível */
  }
  window.addEventListener('cookie-consent-change', (e) => {
    if (e.detail === 'accepted') loadPixel();
  });
}
